<template>
    <div class="layerManage">
        <el-tree :default-checked-keys="defaultList" :expand-on-click-node="false" @check-change="checkChange"
            :data="Listdata" show-checkbox default-expand-all node-key="name" ref="tree" highlight-current
            :props="defaultProps" @node-click="handleNodeClick">
            <!-- <span @node-contextmenu="contextmenu" class="custom-tree-node-card" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
            </span> -->
        </el-tree>
    </div>
</template>

<script>
export default {
    data() {
        return {
            Listdata: [
                {
                    name: '影像图层',
                    children: []
                },
                {
                    name: '地形图层',
                    type: 'terrain',
                },
                // {
                //     name: '模型图层',
                //     children: []
                // }
            ],
            defaultList: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
        };
    },

    created() {
        this.initTree();
    },
    mounted() {

    },

    methods: {
        initTree() {
            var maps = DBmap.getBasemaps();
            for (let i = 0, len = maps.length; i < len; i++) {
                this.Listdata[0].children.push({
                    name: maps[i].name,
                    id: maps[i].name,
                    type: 'map'
                });

                if (maps[i].show) {
                    this.defaultList.push(maps[i].name);
                }
            }

            // var layers = DBmap.getLayers();
            // for (let i = 0, len = layers.length; i < len; i++) {
            //     this.Listdata[2].children.push({
            //         name: layers[i].name,
            //         id: layers[i].name,
            //         type: 'layer'
            //     });

            //     if (layers[i].show) {
            //         this.defaultList.push(layers[i].name);
            //     }
            // }

            if (DBmap.getTerrainProviderState()) {
                this.defaultList.push('地形图层');
            }
        },

        checkChange(item, bool, cBool) {
            DBmap.setLayerVisible(item.name, item.type, bool)
        },

        handleNodeClick(item, node, el) {
           this.$refs["tree"].setChecked(node.data,!node.checked,false);
            console.log(node);
            if (item.type == "layer") {
                DBmap.zoomToLayer(item.name);
            }
        }

    },
};
</script>

<style lang="scss">
.layerManage {
    .el-tree {
        background: transparent;
        color: #FFFFFF;

        .el-tree-node__content:hover,
        .el-upload-list__item:hover {
            background-color: transparent;
            color: #83E9FF;
        }

        .el-checkbox__inner {
            background-color: transparent;
        }
    }

    .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
        background-color: transparent !important;
        color: #83E9FF !important;
    }

    .el-tree-node__expand-icon {
        color: #FFFFFF !important;
    }

    .el-tree-node:focus>.el-tree-node__content {
        background-color: transparent !important;
    }
}
</style>